import { strings } from "../strings";

interface ConversationEmptyStateProps {
  title?: string;
  description?: string;
  className?: string;
}

/**
 * Empty state for conversation area - shows when bot hasn't spoken yet
 */
export function ConversationEmptyState({
  title = strings.emptyState.title,
  description = strings.emptyState.description,
  className,
}: ConversationEmptyStateProps) {
  return (
    <div
      className={`flex w-full h-full flex-col items-center justify-center gap-3 p-8 text-center ${className || ""}`}
    >
      <div className="flex flex-col gap-1">
        <h3 className="text-sm font-medium text-foreground">{title}</h3>
        {description && (
          <p className="text-sm text-muted-foreground">{description}</p>
        )}
      </div>
    </div>
  );
}
